import {jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import {AssignmentInd as AssignmentIndIcon} from '@mui/icons-material'
import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'
import useTooltip from '~/hooks/useTooltip'

import BaseButton from '../../../../components/BaseButton'
import {MenuPosition} from '../../../../hooks/useCoords'
import useMenu from '../../../../hooks/useMenu'

import textOverflow from '../../../../styles/helpers/textOverflow'
import {PALETTE} from '../../../../styles/paletteV3'
import avatarUser from '../../../../styles/theme/images/avatar-user.svg'
import lazyPreload from '../../../../utils/lazyPreload'

const label = {
  ...textOverflow,
  color: PALETTE.SLATE_700,
  display: 'block',
  flex: 1,
  fontSize: 12,
  fontWeight: 400,
  lineHeight: '24px',
  maxWidth: '100%',
  textAlign: 'left'
} 

const AvatarButton = styled(BaseButton)({
  border: 0,
  boxShadow: 'none',
  display: 'flex',
  fontSize: 'inherit',
  height: 24,
  lineHeight: 'inherit',
  outline: 0,
  padding: 0,
  maxWidth: '100%',
  ':hover,:focus,:active': {
    boxShadow: 'none'
  },
  ':hover > div,:focus > div': {
    borderColor: PALETTE.SLATE_700,
    color: PALETTE.SLATE_700
  }
})

const Avatar = styled('div')(({isAssigned}) => ({
  backgroundColor: isAssigned ? 'transparent' : PALETTE.SLATE_600,
  color: isAssigned ? 'transparent' : undefined,
  borderRadius: '100%',
  height: 24,
  marginRight: 6,
  width: 24
}))

const AvatarImage = styled('img')({
  borderRadius: '100%',
  height: 24,
  marginRight: 4,
  width: 24
})

const AvatarLabel = styled('div')({
  ...label,
  color: PALETTE.SLATE_600,
  flex: 1,
  fontWeight: 600,
  minWidth: 0,
  overflowWrap: 'break-word'
})

const TooltipToggle = styled('div')({
  display: 'inline-flex',
  width: '100%'
})

const StyledIcon = styled('div')({
  alignContent: 'center',
  alignItems: 'center',
  color: PALETTE.WHITE,
  cursor: 'pointer',
  display: 'flex',
  svg: {
    fontSize: 22
  },
  height: 22,
  width: 22,
  justifyContent: 'center',
  position: 'relative',
  top: 1
})








const TaskFooterUserAssigneeMenuRoot = lazyPreload(
  () =>
    import(
      /* webpackChunkName: 'TaskFooterUserAssigneeMenuRoot' */ '../TaskFooterUserAssigneeMenuRoot'
    )
)

const TaskFooterUserAssignee = (props) => {
  const {area, canAssign, task: taskRef, useTaskChild} = props
  const task = useFragment(
    graphql`
      fragment TaskFooterUserAssignee_task on Task {
        ...TaskFooterUserAssigneeMenuRoot_task
        user {
          picture
          preferredName
        }
        team {
          name
        }
      }
    `,
    taskRef
  )
  const {user} = task
  const userImage = _optionalChain([user, 'optionalAccess', _ => _.picture]) || avatarUser
  const preferredName = _optionalChain([user, 'optionalAccess', _2 => _2.preferredName]) || 'Unassigned'
  const {togglePortal, originRef, menuPortal, menuProps} = useMenu(MenuPosition.UPPER_LEFT)
  const {
    tooltipPortal,
    openTooltip,
    closeTooltip,
    originRef: tipRef
  } = useTooltip(MenuPosition.UPPER_CENTER)
  return (
    _jsxs(_Fragment, { children: [
      _jsx(TooltipToggle, {
        onMouseEnter: openTooltip,
        onMouseLeave: closeTooltip,
        onClick: closeTooltip,
        ref: tipRef,
 children: 
        _jsxs(AvatarButton, {
          'aria-label': "Assign this task to a teammate"     ,
          onClick: canAssign ? togglePortal : undefined,
          onMouseEnter: TaskFooterUserAssigneeMenuRoot.preload,
          ref: originRef,
 children: [
          _jsx(Avatar, { isAssigned: !!user, children: 
            user ? (
              _jsx(AvatarImage, { alt: preferredName, src: userImage,} )
            ) : (
              _jsx(StyledIcon, { children: 
                _jsx(AssignmentIndIcon, {} )
              })
            )
          })
          , _jsx(AvatarLabel, { children: preferredName})
        ]})
      })
      , tooltipPortal(_jsx('div', { children: 'Reassign Responsibility'}))
      , menuPortal(
        _jsx(TaskFooterUserAssigneeMenuRoot, {
          menuProps: menuProps,
          task: task,
          area: area,
          useTaskChild: useTaskChild,}
        )
      )
    ]})
  )
}

export default TaskFooterUserAssignee
